module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v("\nEn cours de construction... soyez patients !!\n    "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28a9cdbf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/my-account/my-teams.vue
// module id = 725
// module chunks = 0